import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/sidebars/more.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6827e3bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_4 = ["onClick"]

import { ref, onMounted, onUnmounted } from "vue";

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDropdown',
  props: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: { type: Array as any, default: () => [] },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  item: { type: Object, default: () => {} },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const props = __props;

// Define emits
const emit = __emit;

// Dropdown state
const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);

// Toggles the dropdown menu
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectOption = (option: any) => {
  emit("change", { ...props.item, stockTypeId: option?.id });
  isOpen.value = false;
};

// Closes the dropdown when clicking outside
const handleOutsideClick = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false;
  }
};

// Add and remove event listener for outside clicks
onMounted(() => {
  document.addEventListener("click", handleOutsideClick);
});

onUnmounted(() => {
  document.removeEventListener("click", handleOutsideClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-dropdown",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("button", {
      class: "dropdown-button",
      onClick: toggleDropdown
    }, _hoisted_2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rows, (option, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: index,
              class: "dropdown-item",
              onClick: _withModifiers(($event: any) => (selectOption(option)), ["stop"])
            }, _toDisplayString(_ctx.$t(option?.name)), 9, _hoisted_4)), [
              [_vShow, _ctx.$psm(option.permissionKey)]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})